/**
 * Funil — Em breve placeholder (Story DEMO.7).
 * Original implementation preserved in git history.
 */
import { AppLayout } from "@/components/layout/AppLayout";
import { ComingSoon } from "@/components/shared/ComingSoon";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function Funil() {
  usePageTitle("Funil de Vendas");
  return (
    <AppLayout>
      <ComingSoon
        title="Funil de Vendas"
        description="Acompanhe sua jornada de conversão"
      />
    </AppLayout>
  );
}
